import axios from 'axios';
import platform from 'platform';
import p from '../../../package.json';
import getDeviceId from './deviceId.service';

const baseUrl = process.env.REACT_APP_API_LOQUIS_BASE_URL;
const challengeBaseUrl = process.env.REACT_APP_API_CHALLENGE_BASE_URL;
const versionedChallengeBaseUrl = challengeBaseUrl?.match(/\/v\d+$/)
  ? challengeBaseUrl
  : `${challengeBaseUrl?.replace(/\/$/, '')}/v1`;
let interceptorsInitialized = false;

const getDefaultLanguage = () => (navigator.language.split('-')[0] === 'it' ? 'it' : 'en');

const setDefaultHeaders = async (getLngHeader: Function) => {
  const language = getLngHeader() || getDefaultLanguage();

  axios.defaults.headers.common['Accept-Language'] = language;
  axios.defaults.headers.common['X-Loquis-App-Platform'] = 'web';
  axios.defaults.headers.common['X-Loquis-App-OSName'] = platform.os?.family ?? '';
  axios.defaults.headers.common['X-Loquis-App-OSVersion'] = platform.os?.version ?? '';
  axios.defaults.headers.common['X-Loquis-App-DeviceID'] = await getDeviceId(baseUrl, language);
  axios.defaults.headers.common['X-Loquis-App-AppID'] = 'challenge.loquis.com';
  axios.defaults.headers.common['X-Loquis-App-AppVersion'] = p.version;
};

export const initAxiosInterceptors = async (getLngHeader: Function) => {
  await setDefaultHeaders(getLngHeader);

  if (interceptorsInitialized) {
    return;
  }

  axios.interceptors.request.use(
    async function (config) {
      const tgtBE = config.url?.match(/\/[a-zA-Z0-9]+\//);

      switch (tgtBE?.[0]) {
        case '/frb/':
          config.url = versionedChallengeBaseUrl + config.url.replace('/frb/', '/');
          break;
        case '/int/':
          config.url = baseUrl + config.url.replace('/int/', '/');
          break;
      }
      const language = getLngHeader() || getDefaultLanguage();

      config.headers['Accept-Language'] = language;
      config.headers['X-Loquis-App-Platform'] = 'web';
      config.headers['X-Loquis-App-OSName'] = platform.os?.family ?? '';
      config.headers['X-Loquis-App-OSVersion'] = platform.os?.version ?? '';
      config.headers['X-Loquis-App-AppID'] = 'challenge.loquis.com';
      config.headers['X-Loquis-App-AppVersion'] = p.version;

      if (!config.url?.includes('/register-device')) {
        config.headers['X-Loquis-App-DeviceID'] = await getDeviceId(baseUrl, language);
      }

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      const url = response.config.url;

      if (url.indexOf(versionedChallengeBaseUrl) === 0) {
        return response.data?.result ?? response.data;
      }
      if (url.indexOf(baseUrl) === 0) {
        return response.data.result;
      }
      return response.data;
    },
    function (error) {
      const errData = error.response?.data || error;
      
      if (errData?.error_code === 'BAD-DEVICE') {
        localStorage.removeItem('loq-chl:deviceId');
        window.location.reload();
      }
      
      return Promise.reject(errData);
    }
  );

  interceptorsInitialized = true;
};
